module.exports = __webpack_public_path__ + "static/media/myPak-NG-Logo-Full.8d9eab81.png";